<nz-range-picker
  [nzFormat]="'short' | localeDateFormat"
  [nzSize]="'small'"
  [nzPlaceHolder]="['filters.rangeMin' | translate, 'filters.rangeMax' | translate]"
  [nzSeparator]="'|'"
  [(ngModel)]="datesRange"
  (ngModelChange)="onRangeSelect($event)"
></nz-range-picker>